import { render } from "./LoginSimple.vue?vue&type=template&id=95df64b6"
import script from "./LoginSimple.vue?vue&type=script&lang=js"
export * from "./LoginSimple.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__